import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  card: {
    margin: '0 6px 13px 6px',
  },
  imgCard: {
    display: 'block',
    width: 168,
    height: 175,
    objectFit: 'cover',
    borderRadius: 10,
    boxShadow: '0px 8px 12px rgba(93, 100, 188, 0.14)',
    '@media(max-width: 374px)': {
      width: '100%',
    },
  },
  title: {
    marginTop: 10,
    fontFamily: theme.fonts.family.primary,
    fontWeight: 500,
    fontSize: theme.fonts.sizes.font14PX,
    color: theme.colors.light.lightSteelBlue,
  },
  quantity: {
    fontWeight: 'normal',
    fontSize: theme.fonts.sizes.font12PX,
    color: theme.colors.light.lightCyan,
  },
}));
